module.exports = __webpack_public_path__ + "static/media/supportTimelifeHover.cfc9872c.svg";